module.exports = __webpack_public_path__ + "static/media/ConsupediaLogo.1cb08786.png";